import { getSiteName } from '../../utils/url';

import FleetPartners from './FleetPartners';
import FleetPlus from './FleetPlus';
import FleetSmart from './FleetSmart';
import isIframe from '../../utils/isIframe';
import iframes from './iframes';

const THEMES = {
  FleetPartners,
  FleetPlus,
  FleetSmart,
  iframes,
};

const getTheme = () => {
  const host = getSiteName();
  return isIframe ? THEMES.iframes[host] : THEMES[host];
};

export default getTheme();



// WEBPACK FOOTER //
// ./src/themes/themes/index.js